import React from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
}

/**
 * Reusable password input with visibility toggle.
 * - Closed eye (VisibilityOff) → hidden (type="password")
 * - Open eye (Visibility) → visible (type="text")
 */
const PasswordInput: React.FC<PasswordInputProps> = ({ hasError, ...inputProps }) => {
  const [visible, setVisible] = React.useState(false);

  const toggle = () => setVisible((prev) => !prev);

  const handleToggleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggle();
    }
  };

  const inputType = visible ? 'text' : 'password';
  const ariaLabel = visible ? 'Hide password' : 'Show password';

  return (
    <div className="password-input-wrapper">
      <input
        {...inputProps}
        type={inputType}
        className={`${inputProps.className || ''} ${hasError ? 'error' : ''}`.trim()}
      />
      <button
        type="button"
        className="password-toggle-button"
        aria-label={ariaLabel}
        onClick={toggle}
        onKeyDown={handleToggleKeyDown}
      >
        {visible ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
      </button>
    </div>
  );
};

export default PasswordInput;

